import FenetresAide from 'enums/FenetresAide'

export default class Utilisateur {
  private _nom: string

  private _prenom: string

  private _roles: string[]

  private _fenetresAide: { [key in FenetresAide]: boolean }

  constructor(
    nom: string,
    prenom: string,
    roles: string[],
    fenetresAide: { [key in FenetresAide]: boolean }
  ) {
    this._nom = nom
    this._prenom = prenom
    this._roles = roles
    this._fenetresAide = fenetresAide
  }

  get nom(): string {
    return this._nom
  }

  get prenom(): string {
    return this._prenom
  }

  get roles(): string[] {
    return this._roles
  }

  fenetreAide(key: FenetresAide): boolean {
    return this._fenetresAide[key]
  }

  markFenetreAideAsSeen(key: FenetresAide): void {
    this._fenetresAide[key] = true
  }
}
